<template>
  <div class="wl-spinner-text-list">
    <div class="wl-spinner-text-list__item">
      <TzMarkdown
        class="wl-spinner-text-list__text"
        :class="{ 'wl-spinner-text-list__text--loading': item.opacity !== 1 }"
        :style="{ opacity: item.opacity }"
        :content="item.title"
      />
      <TzSpinner
        :is-check="item.setCheck"
        spinner-size="18"
        :spinner-color="spinnerColor"
        :spinner-stroke="spinnerStroke"
        check-size="18"
        :check-color="checkColor"
        :spinner-animation="true"
        animation-style="check"
        :check-delay="item.checkDelay"
        :spinner-delay="item.spinnerDelay"
        :is-starting-spin="item.isStartingSpin"
        @tz-spinner-start-spin="onStartSpin(index)"
        @tz-spinner-check="changeToCheck(index)"
      />
    </div>
  </div>
</template>

<script>
import TzSpinner from '@trazi/tz-spinner/src/tz-spinner.vue';
import TzMarkdown from '@trazi/tz-markdown/src/tz-markdown.vue';
export default {
  name: 'WlSpinnerTextList',
  components: { TzSpinner, TzMarkdown },
  data() {
    return {
      currentPosition: this.position
    };
  },
  props: {
    // Index of current item in list
    index: {
      type: Number,
      required: true
    },
    // Array of items to have spinner for
    spinnerTextArray: {
      type: Array,
      required: true
    },
    // Current item in list
    item: {
      type: Object,
      required: true
    },
    // Indicates which item to scroll to upon previous item becoming check
    position: {
      type: Number,
      default: 0
    },
    // Only add to calculate the width of the slide (ex. Step 3 of landing flow)
    listWidth: {
      type: Number
    },
    // Optional color hex string to override dfeault check color
    checkColor: {
      type: String,
      default: '#FF6363'
    },
    // Optional color hex string to override default spinner color
    spinnerColor: {
      type: String,
      default: '#4448B2'
    },
    // Optional stroke width for spinner to override default size
    spinnerStroke: {
      type: String,
      default: '6'
    }
  },
  methods: {
    changeToCheck(index) {
      this.$emit('wl-spinner-text-list-item-end', index);
      this.spinnerTextArray[index].setCheck = true;
      const spinnerLength = this.spinnerTextArray.length;

      if (
        !this.spinnerTextArray[index].isVisible &&
        this.spinnerTextArray[index].setCheck
      ) {
        this.spinnerTextArray[index].opacity = 1;
      }

      for (let i = 0; i < spinnerLength; i++) {
        // This checks if last item is set to true, then emit event
        if (this.spinnerTextArray[spinnerLength - 1].setCheck) {
          setTimeout(() => {
            this.$emit('wl-spinner-text-list-finished');
          }, 100);
          return;
        }

        // Decrement current position by width of list wrapper - margin
        if (this.spinnerTextArray[i].setCheck) {
          this.currentPosition -= this.listWidth - 15;
          this.$emit(
            'wl-spinner-text-list-update-position',
            this.currentPosition
          );
        }
      }
    },
    onStartSpin(index) {
      this.$emit('wl-spinner-text-list-item-start', index);
      const spinnerLength = this.spinnerTextArray.length;

      if (this.spinnerTextArray[index].isVisible) {
        this.spinnerTextArray[index].opacity = 1;
      }

      this.spinnerTextArray[index].isStartingSpin = true;
    }
  }
};
</script>
